/*
 * Created Date: 26-11-2022, 10:08:31 am
 * Author: Hai Tran
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2022 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { useTheme } from '@mui/material'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'

const CoreFieldSet = props => {
	const { title, className, error, required } = props
	const theme = useTheme()
	return (
		<fieldset
			className={clsx('border rounded-md p-3', className)}
			style={{ borderColor: error ? theme.palette.error.main : theme.palette.divider }}
		>
			<legend style={{ color: error ? theme.palette.error.main : theme.palette.text.secondary, fontSize: 14 }}>
				{title} {required && <span className="text-red-400">*</span>}
			</legend>
			{props.children}
		</fieldset>
	)
}

// CoreFieldSet.defaultProps = {}

CoreFieldSet.propTypes = {
	className: PropTypes.string,
	title: PropTypes.any,
	required: PropTypes.bool
}

export default React.memo(CoreFieldSet)
